import { render } from "./TakeAway.vue?vue&type=template&id=16dfd47c"
import script from "./TakeAway.vue?vue&type=script&lang=js"
export * from "./TakeAway.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__